import styles from './imagePreview.module.css';

interface Props {
  imageUrl: string;
  name: string;
  width?: number;
  height?: number;
}

export default function ImagePreview({ imageUrl, name, width = 132, height = 132 }: Props) {
  return <img src={imageUrl} alt={name} className={styles.productPreviewImage} width={width} height={height} />;
}
